import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { createService } from "../../../../actions/serviceActions";
import {
  Button,
  Flex,
  HStack,
  Switch,
  Box,
  Heading,
  Text,
  Spinner,
  Tooltip,
  Icon,
  IconButton,
} from "@chakra-ui/react";
import {
  primary,
  white,
  textSecondary,
  backgroundLight,
  primaryAlt,
  buttonRed,
  buttonRedText,
  // color8,
} from "../../../../utils/colors";
// import InputField from "../../../../components/input/InputField";
import { useTranslation } from "react-i18next";
// import ServiceGroupSelect from "../../../../components/select/ServiceGroupSelect";
// import dayjs from "dayjs";
// import SidePanelHeader from "../../../../components/sidepanel/SidePanelHeader";
import FormControlDefault from "../../../../components/input/FormControlDefault";
import FormControlServiceGroup from "../../../../components/input/FormControlServiceGroup";
import FormControlDuration from "../../../../components/input/FormControlDuration";
// import FormControlSwitch from "../../../../components/input/FormControlSwitch";
import { SERVICE_CREATE_RESET } from "../../../../constants/serviceConstants";
// import useFormattedNumber from "../../../../hooks/useFormattedNumber"; // Adjust the path accordingly
import { motion } from "framer-motion";
import useThemeColors from "../../../../hooks/useThemeColors";
import {
  // formatNumberWithCommas,
  removeCommas,
} from "../../../../utils/formatUtils"; // Adjust the path accordingly
import StatusButtonNew from "../../../../components/buttons/StatusButtonNew";
import { FaArrowLeftLong, FaCircleInfo, FaXmark } from "react-icons/fa6";
// import { TbDental } from "react-icons/tb";
import { useParams } from "react-router-dom";
import FormControlPriceInput from "../../../../components/input/FormControlPriceInput";
import FormControlPriceType from "../../../../components/input/FormControlPriceType";
import useIsMobile from "../../../../hooks/useIsMobile";

const CreateService = ({ close, tenant }) => {
  // GENERAL
  const { slug } = useParams();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const isMobile = useIsMobile();

  //COLORS
  const { whiteMode, newBorderMode, textPrimaryMode, backgroundLightMode } =
    useThemeColors();

  // CONSTANTS
  const [loading, setLoading] = useState(false);
  const [loadingDisplay, setLoadingDisplay] = useState(true);

  const [name, setName] = useState("");
  const [price, setPrice] = useState("");
  const [maxPrice, setMaxPrice] = useState("");

  const [serviceGroup, setServiceGroup] = useState();
  const [duration, setDuration] = useState("");
  const [priceVariations, setPriceVariations] = useState(false);
  const [priceRange, setPriceRange] = useState(false);
  const [status, setStatus] = useState("active");
  const [defaultPublicReimbursementCode, setDefaultPublicReimbursementCode] =
    useState("");

  const [namePlaceholder, setNamePlaceholder] = useState("");
  const [codePlaceholder, setCodePlaceholder] = useState("");
  const [operatingCountry, setOperatingCountry] = useState(
    tenant?.operatingCountry || "US" // Default to US if not set
  );

  // HANDLERS

  const closeHandler = () => {
    close();
    dispatch({ type: SERVICE_CREATE_RESET });
  };

  // const submitHandler = (e) => {
  //   e.preventDefault();

  //   dispatch(
  //     createService(
  //       name,
  //       price,
  //       maxPrice,
  //       priceRange,
  //       priceVariations,
  //       duration,
  //       serviceGroup,
  //       // products,
  //       status
  //     )
  //   );
  // };
  const submitHandler = (e) => {
    e.preventDefault();

    dispatch(
      createService(
        slug,
        name,
        removeCommas(price), // ✅ Remove commas before sending
        removeCommas(maxPrice), // ✅ Remove commas before sending
        priceRange,
        priceVariations,
        duration,
        serviceGroup,
        status,
        defaultPublicReimbursementCode
      )
    );
  };

  const handlePriceVariationsChange = (e) => {
    setPriceVariations(!priceVariations);
  };

  const handlePriceRangeChange = (e) => {
    setPriceRange(!priceRange);
  };

  // Custom input for minutes
  const customDuration = Math.round(duration / 60); // Convert back to minutes for display

  // ERRORS
  const isNameError = name === "";
  const isPriceError = price === "";
  const isServiceGroupError =
    serviceGroup === "" || serviceGroup === null || serviceGroup === undefined;
  const isDurationError = duration === "";
  const isMaxPriceError =
    priceRange &&
    (maxPrice === "" || maxPrice === null || maxPrice === undefined);

  // TOOLTIP VALIDATION MESSAGES
  const tooltipMessages = [];

  if (isNameError) tooltipMessages.push(t("formError.serviceNameRequired"));
  if (isPriceError) tooltipMessages.push(t("formError.priceRequired"));
  if (isServiceGroupError)
    tooltipMessages.push(t("formError.serviceGroupRequired"));
  if (isDurationError) tooltipMessages.push(t("formError.durationRequired"));
  if (isMaxPriceError) tooltipMessages.push(t("formError.maxPriceRequired"));

  // USE EFFECT
  useEffect(() => {
    const timeout = setTimeout(() => {
      setLoadingDisplay(false);
    }, 300); // CHANGE THIS TO HAVE A LONGER LOADING TIME

    // Cleanup function to clear the timeout if the component unmounts
    return () => clearTimeout(timeout);
  }, []);

  useEffect(() => {
    // Update placeholders when reimbursementType or operatingCountry changes
    if (tenant && tenant.operatingCountry) {
      setOperatingCountry(tenant.operatingCountry);
      if (operatingCountry === "US") {
        setNamePlaceholder(t("reimbursement.serviceCodeUS"));
        setCodePlaceholder(t("reimbursement.serviceCodePlaceholderUS"));
      } else if (operatingCountry === "GB") {
        setNamePlaceholder(t("reimbursement.serviceCodeGB"));
        setCodePlaceholder(t("reimbursement.serviceCodePlaceholderGB"));
      } else if (operatingCountry === "LT") {
        setNamePlaceholder(t("reimbursement.serviceCodeLT"));
        setCodePlaceholder(t("reimbursement.serviceCodePlaceholderLT"));
      } else {
        setNamePlaceholder(t("reimbursement.serviceCode"));
        setCodePlaceholder(t("reimbursement.serviceCodePlaceholder"));
      }
    } else {
      setNamePlaceholder(t("reimbursement.serviceCode"));
      setCodePlaceholder(t("reimbursement.serviceCodePlaceholder"));
    }
  }, [tenant, operatingCountry]);

  // LOGS

  // console.log("name", name);
  // console.log("price", price);
  // console.log("duration", duration);
  // console.log("serviceGroup", serviceGroup);
  // console.log("priceVariations", priceVariations);
  // console.log("priceRange", priceRange);
  // console.log("maxPrice", maxPrice);
  // console.log("tooltipMessages", tooltipMessages);

  return (
    <>
      {loading || loadingDisplay ? (
        <Flex bg={whiteMode} align="center" justify="center" w="100%" h="100%">
          <Spinner color={primary} size="lg" />
        </Flex>
      ) : (
        <Box
          position="relative"
          as={motion.div}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 0.2 } }}
          w="100%"
          h="100%"
        >
          <form
            onSubmit={submitHandler}
            style={{
              height: "100%",
            }}
          >
            <Flex w="100%" h="100%" direction="column">
              {/* HEADER START */}
              <Flex
                justify="space-between"
                align="center"
                p={["1.25rem 1.5rem 1.25rem", "1.25rem 2rem 1.25rem"]}
                borderBottom={`1px solid ${newBorderMode}`}
                mb="0rem"
                position="relative"
                zIndex={90}
                w="100%"
              >
                <Flex align="center">
                  {!isMobile && (
                    <IconButton
                      bg={backgroundLightMode}
                      border={`1px solid ${backgroundLightMode}`}
                      color={textSecondary}
                      icon={<FaArrowLeftLong />}
                      borderRadius="10.75rem"
                      fontSize="0.875rem"
                      onClick={closeHandler}
                      mr="1rem"
                      _hover={{
                        bg: primaryAlt,
                        color: white,
                        border: primaryAlt,
                      }}
                    />
                  )}

                  <Flex align="center">
                    <Heading
                      fontSize={["1rem", "1.125rem"]}
                      color={textPrimaryMode}
                      fontWeight="600"
                      mr={4}
                    >
                      {t("service.createService")}
                    </Heading>
                    {/* {status} */}
                  </Flex>
                </Flex>

                <Flex align="center" justify="flex-end" gap="1rem">
                  {!isMobile && (
                    <Tooltip
                      p="0.5rem 1rem"
                      borderRadius="1rem"
                      label={
                        <Flex
                          direction="column"
                          justify="center"
                          align="center"
                        >
                          <Text
                            fontSize="xs"
                            fontWeight="500"
                            textAlign="center"
                          >
                            {t("service.newServiceInfo")}
                          </Text>
                        </Flex>
                      }
                    >
                      <Flex align="center">
                        <Icon
                          as={FaCircleInfo}
                          fontSize="0.875rem"
                          color={primaryAlt}
                        />
                      </Flex>
                    </Tooltip>
                  )}

                  <StatusButtonNew
                    isSmall
                    currentStatus={status}
                    options="serviceNew"
                    onUpdateStatus={setStatus}
                    size={["sm", "md"]}
                    p={["0 1rem", "0 2rem"]}
                    fontSize={["0.75rem", "0.875rem"]}
                  />

                  {isMobile && (
                    <IconButton
                      position="relative"
                      // top="1.5rem"
                      // right="1.5rem"
                      size="sm"
                      bg={backgroundLight}
                      color={textSecondary}
                      onClick={closeHandler}
                      borderRadius="10rem"
                      _hover={{ bg: primaryAlt, color: white }}
                    >
                      <Icon as={FaXmark} />
                    </IconButton>
                  )}
                </Flex>
              </Flex>
              {/* HEADER END */}
              {/* MAIN START */}
              <Flex
                w="100%"
                h="100%"
                direction="column"
                overflowY="auto"
                p={["1rem 0rem 7rem", "1rem 2rem 7rem"]}
              >
                {/* SERVICE DETAILS START */}
                <Flex direction="column" w="100%">
                  <Text
                    fontSize="0.875rem"
                    fontWeight="600"
                    color={textPrimaryMode}
                    m="0 0 0.5rem"
                    p={["0 0 0 1.5rem", "initial"]}
                  >
                    {t("service.details")}
                  </Text>
                  <Flex
                    direction="column"
                    w="100%"
                    bg={backgroundLight}
                    borderRadius="1rem"
                    p="1.25rem 1.5rem 0.25rem"
                  >
                    <Flex
                      gap={["0rem", "2rem", "2rem"]}
                      w="100%"
                      direction={["column", "row", "row"]}
                    >
                      <FormControlDefault
                        type="text"
                        isRequired
                        size="lg"
                        labelFontSize="0.8rem"
                        label={t("form.serviceName")}
                        value={name}
                        placeholder={t("placeholder.serviceName")}
                        onChange={(e) => {
                          setName(e.target.value);
                        }}
                        isError={isNameError}
                        w="100%"
                        errorMessage={t("formError.serviceNameRequired")}
                      />
                    </Flex>

                    <Flex
                      gap={["0rem", "2rem", "2rem"]}
                      w="100%"
                      direction={["column", "row", "row"]}
                    >
                      <FormControlServiceGroup
                        slug={slug}
                        label={t("form.serviceGroup")}
                        value={serviceGroup}
                        labelFontSize="0.8rem"
                        onChange={(selectedOption) => {
                          setServiceGroup(selectedOption.value);
                        }}
                        isRequired={true} //
                        isError={isServiceGroupError}
                        errorMessage={t("formError.serviceGroupRequired")}
                        w={["100%", "50%"]}
                      />
                      <FormControlDuration
                        label={t("form.duration")}
                        labelFontSize="0.8rem"
                        value={duration}
                        placeholder={t("placeholder.duration")}
                        onChange={(selectedOption) => {
                          setDuration(selectedOption.value);
                        }}
                        isRequired={true}
                        isError={isDurationError}
                        w={["100%", "50%"]}
                      />
                    </Flex>

                    <Flex></Flex>
                  </Flex>
                </Flex>
                {/* SERVICE DETAILS END */}

                {/* PRICE START */}
                <Flex direction="column" w="100%" mt="1.5rem">
                  <Text
                    fontSize="0.875rem"
                    fontWeight="600"
                    color={textPrimaryMode}
                    m="0 0 0.5rem"
                    p={["0 0 0 1.5rem", "initial"]}
                  >
                    {t("service.price")}
                  </Text>
                  <Flex
                    direction="column"
                    w="100%"
                    bg={backgroundLight}
                    borderRadius="1rem"
                    p="1.25rem 1.5rem 0.25rem"
                  >
                    <Flex
                      gap={["0rem", "2rem", "2rem"]}
                      w="100%"
                      direction={["column", "row", "row"]}
                    >
                      <FormControlPriceType
                        label={t("form.priceType")}
                        value={priceVariations}
                        onChange={(val) => setPriceVariations(val)}
                        isRequired
                        w={["100%", "50%"]}
                      />

                      <Flex w={["100%", "50%"]} position="relative" gap="2rem">
                        <Flex
                          position="absolute"
                          top="0px"
                          right="0.5rem"
                          zIndex={1}
                        >
                          <Text
                            fontSize="xs"
                            fontWeight="500"
                            color={textSecondary}
                            mr={1}
                          >
                            {t("form.priceRange")}
                          </Text>
                          <Switch
                            id="price-range"
                            size="sm"
                            isChecked={priceRange}
                            onChange={handlePriceRangeChange}
                          />
                        </Flex>

                        {!priceRange ? (
                          <>
                            <FormControlPriceInput
                              label={t("form.price")}
                              size="lg"
                              labelFontSize="0.8rem"
                              value={price}
                              onChange={(val) => setPrice(val)}
                              isError={isPriceError}
                              // isTouched={true}
                              isRequired
                              // errorMessage={t("formError.priceRequired")}
                              placeholder={t("placeholder.price")}
                              w="100%"
                            />
                          </>
                        ) : (
                          <>
                            <HStack gap={4}>
                              <FormControlPriceInput
                                label={
                                  priceRange
                                    ? t("form.priceFrom")
                                    : t("form.price")
                                }
                                size="lg"
                                labelFontSize="0.8rem"
                                value={price}
                                onChange={(val) => setPrice(val)}
                                // isError={isPriceError}
                                // isTouched={true}
                                isRequired
                                // errorMessage={t("formError.priceRequired")}
                                placeholder={t("placeholder.price")}
                                w="50%"
                              />
                              <FormControlPriceInput
                                label={t("form.priceTo")}
                                size="lg"
                                labelFontSize="0.8rem"
                                value={maxPrice}
                                onChange={(val) => setMaxPrice(val || "")}
                                // isError={isPriceError}
                                // isTouched={true}
                                isRequired
                                // errorMessage={t("formError.maxPriceRequired")}
                                placeholder={t("placeholder.price")}
                                w="50%"
                              />
                            </HStack>
                          </>
                        )}
                      </Flex>
                    </Flex>

                    {priceVariations && (
                      <Flex
                        bg={white}
                        borderRadius="1rem"
                        p="1rem 2rem 1rem 1rem"
                        mb="1rem"
                      >
                        <Icon
                          as={FaCircleInfo}
                          color={primaryAlt}
                          fontSize="0.875rem"
                          mr="0.5rem"
                          position="relative"
                          top="2px"
                        />
                        <Text
                          fontSize="xs"
                          fontWeight="500"
                          color={textSecondary}
                          lineHeight="1.6"
                        >
                          {t("service.pricePerToothExplanation")}
                        </Text>
                      </Flex>
                    )}
                  </Flex>
                </Flex>

                {/* PRICE END */}

                {/* SERVICE REIMBURSEMENT START */}
                <Flex direction="column" w="100%" m="1.5rem 0 0">
                  <Text
                    fontSize="0.875rem"
                    fontWeight="600"
                    color={textPrimaryMode}
                    m="0 0 0.5rem"
                    p={["0 0 0 1.5rem", "initial"]}
                  >
                    {t("service.reimbursementDetails")}
                  </Text>
                  <Flex
                    direction="column"
                    w="100%"
                    bg={backgroundLight}
                    borderRadius="1rem"
                    p="1.25rem 1.5rem 0.25rem"
                  >
                    <Flex
                      gap={["0rem", "2rem", "2rem"]}
                      w="100%"
                      direction={["column", "row", "row"]}
                    >
                      <FormControlDefault
                        type="text"
                        // isRequired
                        size="lg"
                        labelFontSize="0.8rem"
                        label={namePlaceholder}
                        value={defaultPublicReimbursementCode}
                        placeholder={codePlaceholder}
                        onChange={(e) => {
                          setDefaultPublicReimbursementCode(e.target.value);
                        }}
                        isError={isNameError}
                        w="100%"
                        errorMessage={t("formError.reimbursementCodeRequired")}
                      />
                    </Flex>
                  </Flex>
                </Flex>
                {/* SERVICE REIMBURSEMENT END */}

                {/* BOTTOM START */}
                <Flex
                  align="center"
                  justify="flex-end"
                  position={["relative", "fixed"]}
                  bottom={["initial", "2rem"]}
                  right={["initial", "2rem"]}
                  gap="0.5rem"
                  zIndex={9000}
                  p={["1.5rem 1.5rem", "initial"]}
                >
                  <Tooltip
                    bg={buttonRed}
                    color={buttonRedText}
                    padding="0.5rem 1rem"
                    borderRadius="1rem"
                    placement="top"
                    label={
                      tooltipMessages.length > 0 ? (
                        <Flex
                          direction="column"
                          justify="center"
                          align="center"
                        >
                          {tooltipMessages.map((message, index) => (
                            <Text
                              key={index}
                              color={buttonRedText}
                              fontSize="xs"
                              fontWeight="500"
                              textAlign="center"
                            >
                              {message}
                            </Text>
                          ))}
                        </Flex>
                      ) : null
                    }
                    isDisabled={tooltipMessages.length === 0} // Disable tooltip if no errors
                  >
                    <Button
                      type="submit"
                      minWidth="10rem"
                      bg={textPrimaryMode}
                      size="lg"
                      color={whiteMode}
                      fontSize="sm"
                      borderRadius="10rem"
                      border={`1px solid ${whiteMode}`}
                      _hover={{
                        bg: primaryAlt,
                        color: white,
                        border: `1px solid ${whiteMode}`,
                      }}
                      onClick={submitHandler}
                      isDisabled={tooltipMessages.length > 0} // Disable if any errors exist
                    >
                      {t("service.createService")}
                    </Button>
                  </Tooltip>
                </Flex>

                {/* BOTTOM END */}
              </Flex>
              {/* MAIN END */}
            </Flex>
          </form>
        </Box>
      )}
    </>
  );
};

export default CreateService;
